<template>
  <b-modal ref="modal" title="Resumo do caixa" header-class="border-bottom-0">
    <div class="row">
      <div class="col-md-4">
        <date-input alias="Data inicial" v-model="params.date_start"></date-input>
      </div>
      <div class="col-md-4">
        <date-input alias="Data final" v-model="params.date_end"></date-input>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-sm btn-block btn-primary"
            @click="select()"
          >
            <i class="fas fa-search"></i> Filtrar
          </button>
        </div>
      </div>
    </div>
    <account-resume-list :account-resume="accountResume" />
    <!-- <hr /> -->

    <div slot="modal-footer">
      <button
        role="button"
        class="btn btn-outline-secondary"
        @click="$refs.modal.hide()"
      >
        <i class="fas fa-arrow-left"></i> voltar
      </button>
    </div>
  </b-modal>
</template>

<script>

import AccountResumeList from "@/components/account/sections/AccountResumeList.vue";
import moment from "moment";

export default {
  components : { AccountResumeList },

  data: () => ({
    
    accountResume: {},

    params: {
      account_id: null,
      date_start: null,
      date_end: null,
    },
  }),

  methods: {
    async open(account_id) {
      this.reset(account_id);
      
      await this.select();
      
      this.$refs.modal.show();
    },

    async select() {
      this.$store.commit("showLoading");
      
      let resumeResponse = await this.$store.dispatch(
        "drawer/getDrawerResume",
        this.params
      );

      this.accountResume = resumeResponse.data;
      this.$store.commit("hideLoading");
    },

    reset(account_id) {
      this.params.account_id = account_id;
      this.params.date_start = moment().format("YYYY-MM-DD");
      this.params.date_end = moment().format("YYYY-MM-DD");
    },
  },
};
</script>

<style>
</style>